<ul class="ul-head" (click)="null" (keydown)="null" (keyup)="null">
   
    <li (click)="sysapi.setWindowStatus(1)">
        <div class="app-header-ul-item"><i nz-icon nzType="minus" nzTheme="outline"></i></div>
    </li>
    <li (click)="sysapi.setWindowMaxOrNormal()">
        <div class="app-header-ul-item">
            <i nz-icon [nzType]="sysapi.windwosStatus==2? 'fullscreen-exit' : 'fullscreen'"></i></div>
    </li>
    <li class="close" (click)="sysapi.exitApp()">

        <div class="app-header-ul-item"><i nz-icon nzType="close" nzTheme="outline"></i></div>
    </li>
</ul>